<template>
  <div class="Site PageBox" v-if="articleId">
    <van-nav-bar
      fixed
      :border="false"
      :title="showInfo.title"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <div class="Content" v-html="showInfo.content"></div>
    </div>
  </div>
  <div class="Site PageBox" v-else>
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('home.menu[1]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <van-cell size="large" :title="item.title" is-link v-for="item in InitData.videovTutorial" :key="item.id" :to="`/article/video/${item.id}`" />
      <van-empty :description="$t('help[1]')" v-if="!InitData.videovTutorial.length" />
    </div>
  </div>
</template>

<script>
import he from 'he';
export default {
  name: 'Info',
  components: {
  },
  props: ['articleType','articleId'],
  data() {
    return {
      showInfo: {
        title: ''
      },
    }
  },
  computed: {

  },
  watch: {
    $route(){
      if(this.articleType=='video'){
        this.showInfo = this.InitData.videovTutorial.find(item=>item.id==this.articleId)
      }
      if(this.articleType=='help'){
        this.showInfo = this.InitData.helpList.find(item=>item.id==this.articleId)
      }
      if(this.articleType=='notice'){
        this.showInfo = this.InitData.noticelist.find(item=>item.id==this.articleId)
      }
      if(this.articleType=='invest'){
        this.showInfo = this.InitData.invest.find(item=>item.id==this.articleId)
      }
      if(this.articleType=='news'){
        this.showInfo = this.InitData.news.find(item=>item.id==this.articleId)
      }
       if(this.articleType=='message'){
        this.showInfo = this.MessageList.find(item=>item.id==this.articleId)
        this.showInfo.content = he.decode(this.showInfo.content)
      }
    }
  },
  created() {
    if(this.articleType=='video'){
      this.showInfo = this.InitData.videovTutorial.find(item=>item.id==this.articleId)
    }
    if(this.articleType=='help'){
      this.showInfo = this.InitData.helpList.find(item=>item.id==this.articleId)
    }
    if(this.articleType=='notice'){
      this.showInfo = this.InitData.noticelist.find(item=>item.id==this.articleId)
    }
    if(this.articleType=='invest'){
      this.showInfo = this.InitData.invest.find(item=>item.id==this.articleId)
    }
    if(this.articleType=='news'){
      this.showInfo = this.InitData.news.find(item=>item.id==this.articleId)
    }
    if(this.articleType=='message'){
      this.showInfo = this.MessageList.find(item=>item.id==this.articleId)
      this.showInfo.content = he.decode(this.showInfo.content)
      this.$Model.setMessage({mid:this.articleId})
    }
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
::v-deep img{
  max-width: 100%;
}
.PageBox{color: #000;}

::v-deep .van-nav-bar__content {
  background: linear-gradient(to right,$theme-shallow-color, $theme-color);
  color: #fff;
}
::v-deep .van-nav-bar__title {
  color: #fff;
}
::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
}
</style>